const AboutMe = () => {
  return (
    <section>
      <h2 className="title-font pink-text h2-tag">About Me</h2>
      <p className="white-text p-tag">
        I’m a passionate frontend developer keen on building end-to-end
        products. Want to apply and enhance my current skills and learn some
        new. I’ve harnessed my drive and determination to master the latest
        technologies. Through dedicated learning and hands-on projects, I've
        become adept in crafting seamless and engaging web experiences. My
        toolkit includes HTML, CSS, JavaScript, and I'm well-versed in utilizing
        frameworks like React to bring dynamic functionalities to life.
      </p>
    </section>
  );
};
export default AboutMe;
